export class File {
  id: string;
  fileName: string;
  fullName: string;
  fullPath: string;
  uploadedDateTime: Date;
  extension: string;
  size: number;
  contentType: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.fileName = payload.fileName;
      this.fullName = payload.fullName;
      this.contentType = payload.contentType;
      this.fullPath = payload.fullPath;
      if(payload.uploadedDateTime) {
        this.uploadedDateTime = new Date(payload.uploadedDateTime);
      }
      this.extension = payload.extension;
      this.size = payload.size;
    }
  }
}

export class FileInput {
  id: string;
  key: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.key = payload.key;
    }
  }
}
